import { useCallback } from 'react';
import internalApiClient from '~/app/shared/util/api/internalApiClient';
import usePaginatedEndpointBuilder from '~/app/shared/table3tools/hooks/usePaginatedEndpointBuilder';
import { FilterParamFactory, PaginatedDataFetcher } from '~/app/shared/table3tools/types';

export default function usePaginatedDataFetcher<T>(
    endpoint: string,
    filterParamFactory: FilterParamFactory | undefined,
    apiClient = internalApiClient
): PaginatedDataFetcher<T> {
    const builder = usePaginatedEndpointBuilder(endpoint, filterParamFactory);
    return useCallback(
        async (pagination, sorting, filters) => {
            const url = builder(pagination, sorting, filters);
            const {
                data: {
                    data,
                    pagination: { count },
                },
            } = await apiClient.get<{ data: T[]; pagination: { count: number } }>(url);

            return { data, length: count };
        },
        [apiClient, builder]
    );
}
